"use strict"; // Copyright (c) 2018-2020 WalletLink.org <https://www.walletlink.org/>
// Copyright (c) 2018-2020 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _classCallCheck = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("E:\\Blockchain\\prnts_main_repo\\PrntPlace-main\\client\\node_modules\\@babel\\runtime/helpers/createClass");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkRelay = void 0;

var bind_decorator_1 = __importDefault(require("bind-decorator"));

var crypto_1 = __importDefault(require("crypto"));

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var url_1 = __importDefault(require("url"));

var LinkFlow_1 = require("../components/LinkFlow");

var Snackbar_1 = require("../components/Snackbar");

var WalletLinkConnection_1 = require("../connection/WalletLinkConnection");

var ScopedLocalStorage_1 = require("../lib/ScopedLocalStorage");

var util_1 = require("../util");

var aes256gcm = __importStar(require("./aes256gcm"));

var Session_1 = require("./Session");

var Web3Method_1 = require("./Web3Method");

var Web3RequestCanceledMessage_1 = require("./Web3RequestCanceledMessage");

var Web3RequestMessage_1 = require("./Web3RequestMessage");

var Web3Response_1 = require("./Web3Response");

var Web3ResponseMessage_1 = require("./Web3ResponseMessage");

var WalletLinkRelay =
/*#__PURE__*/
function () {
  function WalletLinkRelay(options) {
    _classCallCheck(this, WalletLinkRelay);

    this.appName = "";
    this.appLogoUrl = null;
    this.attached = false;
    this.walletLinkUrl = options.walletLinkUrl;
    var u = url_1.default.parse(this.walletLinkUrl);
    this.walletLinkOrigin = "".concat(u.protocol, "//").concat(u.host);
    this.storage = new ScopedLocalStorage_1.ScopedLocalStorage("-walletlink:".concat(this.walletLinkOrigin));
    this.session = Session_1.Session.load(this.storage) || new Session_1.Session(this.storage).save();
    this.connection = new WalletLinkConnection_1.WalletLinkConnection(this.session.id, this.session.key, this.walletLinkUrl);
    this.connection.incomingEvent$.pipe(operators_1.filter(function (m) {
      return m.event === "Web3Response";
    })).subscribe({
      next: this.handleIncomingEvent
    }); // if session is marked destroyed, reset and reload

    this.connection.sessionConfig$.pipe(operators_1.filter(function (c) {
      return !!c.metadata && c.metadata.__destroyed === "1";
    })).subscribe({
      next: this.resetAndReload
    });
    this.snackbar = new Snackbar_1.Snackbar({
      darkMode: options.darkMode
    });
    this.linkFlow = new LinkFlow_1.LinkFlow({
      darkMode: options.darkMode,
      version: options.version,
      sessionId: this.session.id,
      sessionSecret: this.session.secret,
      walletLinkUrl: this.walletLinkUrl,
      connected$: this.connection.connected$
    });
    this.connection.connect();
  }

  _createClass(WalletLinkRelay, [{
    key: "resetAndReload",
    value: function resetAndReload() {
      var _this = this;

      this.connection.setSessionMetadata("__destroyed", "1").pipe(operators_1.timeout(1000), operators_1.catchError(function (_) {
        return rxjs_1.of(null);
      })).subscribe(function (_) {
        _this.connection.destroy();

        _this.storage.clear();

        document.location.reload();
      });
    }
  }, {
    key: "setAppInfo",
    value: function setAppInfo(appName, appLogoUrl) {
      this.appName = appName;
      this.appLogoUrl = appLogoUrl;
    }
  }, {
    key: "attach",
    value: function attach(el) {
      if (this.attached) {
        throw new Error("WalletLinkRelay is already attached");
      }

      var container = document.createElement("div");
      container.className = "-walletlink-css-reset";
      el.appendChild(container);
      this.linkFlow.attach(container);
      this.snackbar.attach(container);
    }
  }, {
    key: "getStorageItem",
    value: function getStorageItem(key) {
      return this.storage.getItem(key);
    }
  }, {
    key: "setStorageItem",
    value: function setStorageItem(key, value) {
      this.storage.setItem(key, value);
    }
  }, {
    key: "requestEthereumAccounts",
    value: function requestEthereumAccounts() {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.requestEthereumAccounts,
        params: {
          appName: this.appName,
          appLogoUrl: this.appLogoUrl || null
        }
      });
    }
  }, {
    key: "signEthereumMessage",
    value: function signEthereumMessage(message, address, addPrefix, typedDataJson) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.signEthereumMessage,
        params: {
          message: util_1.hexStringFromBuffer(message, true),
          address: address,
          addPrefix: addPrefix,
          typedDataJson: typedDataJson || null
        }
      });
    }
  }, {
    key: "ethereumAddressFromSignedMessage",
    value: function ethereumAddressFromSignedMessage(message, signature, addPrefix) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.ethereumAddressFromSignedMessage,
        params: {
          message: util_1.hexStringFromBuffer(message, true),
          signature: util_1.hexStringFromBuffer(signature, true),
          addPrefix: addPrefix
        }
      });
    }
  }, {
    key: "signEthereumTransaction",
    value: function signEthereumTransaction(params) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.signEthereumTransaction,
        params: {
          fromAddress: params.fromAddress,
          toAddress: params.toAddress,
          weiValue: util_1.bigIntStringFromBN(params.weiValue),
          data: util_1.hexStringFromBuffer(params.data, true),
          nonce: params.nonce,
          gasPriceInWei: params.gasPriceInWei ? util_1.bigIntStringFromBN(params.gasPriceInWei) : null,
          gasLimit: params.gasLimit ? util_1.bigIntStringFromBN(params.gasLimit) : null,
          chainId: params.chainId,
          shouldSubmit: false
        }
      });
    }
  }, {
    key: "signAndSubmitEthereumTransaction",
    value: function signAndSubmitEthereumTransaction(params) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.signEthereumTransaction,
        params: {
          fromAddress: params.fromAddress,
          toAddress: params.toAddress,
          weiValue: util_1.bigIntStringFromBN(params.weiValue),
          data: util_1.hexStringFromBuffer(params.data, true),
          nonce: params.nonce,
          gasPriceInWei: params.gasPriceInWei ? util_1.bigIntStringFromBN(params.gasPriceInWei) : null,
          gasLimit: params.gasLimit ? util_1.bigIntStringFromBN(params.gasLimit) : null,
          chainId: params.chainId,
          shouldSubmit: true
        }
      });
    }
  }, {
    key: "submitEthereumTransaction",
    value: function submitEthereumTransaction(signedTransaction, chainId) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.submitEthereumTransaction,
        params: {
          signedTransaction: util_1.hexStringFromBuffer(signedTransaction, true),
          chainId: chainId
        }
      });
    }
  }, {
    key: "scanQRCode",
    value: function scanQRCode(regExp) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.scanQRCode,
        params: {
          regExp: regExp
        }
      });
    }
  }, {
    key: "arbitraryRequest",
    value: function arbitraryRequest(data) {
      return this.sendRequest({
        method: Web3Method_1.Web3Method.arbitrary,
        params: {
          data: data
        }
      });
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var hideSnackbarItem = null;
        var id = crypto_1.default.randomBytes(8).toString("hex");
        var isRequestAccounts = request.method === Web3Method_1.Web3Method.requestEthereumAccounts;

        var cancel = function cancel() {
          _this2.publishWeb3RequestCanceledEvent(id);

          _this2.handleWeb3ResponseMessage(Web3ResponseMessage_1.Web3ResponseMessage({
            id: id,
            response: Web3Response_1.ErrorResponse(request.method, "User rejected request")
          }));

          hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
        };

        if (isRequestAccounts) {
          _this2.linkFlow.open({
            onCancel: cancel
          });

          WalletLinkRelay.accountRequestCallbackIds.add(id);
        } else {
          var snackbarProps = {
            message: "Pushed a request to your wallet...",
            showProgressBar: true,
            actions: [{
              info: "Made a mistake?",
              buttonLabel: "Cancel",
              onClick: cancel
            }, {
              info: "Not receiving requests?",
              buttonLabel: "Reset Connection",
              onClick: _this2.resetAndReload
            }]
          };
          hideSnackbarItem = _this2.snackbar.presentItem(snackbarProps);
        }

        WalletLinkRelay.callbacks.set(id, function (response) {
          _this2.linkFlow.close();

          hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();

          if (response.errorMessage) {
            return reject(new Error(response.errorMessage));
          }

          resolve(response);
        });

        _this2.publishWeb3RequestEvent(id, request);
      });
    }
  }, {
    key: "publishWeb3RequestEvent",
    value: function publishWeb3RequestEvent(id, request) {
      var _this3 = this;

      var message = Web3RequestMessage_1.Web3RequestMessage({
        id: id,
        request: request
      });
      this.publishEvent("Web3Request", message, true).subscribe({
        error: function error(err) {
          _this3.handleWeb3ResponseMessage(Web3ResponseMessage_1.Web3ResponseMessage({
            id: message.id,
            response: {
              method: message.request.method,
              errorMessage: err.message
            }
          }));
        }
      });
    }
  }, {
    key: "publishWeb3RequestCanceledEvent",
    value: function publishWeb3RequestCanceledEvent(id) {
      var message = Web3RequestCanceledMessage_1.Web3RequestCanceledMessage(id);
      this.publishEvent("Web3RequestCanceled", message, false).subscribe();
    }
  }, {
    key: "publishEvent",
    value: function publishEvent(event, message, callWebhook) {
      var encrypted = aes256gcm.encrypt(JSON.stringify(Object.assign(Object.assign({}, message), {
        origin: location.origin
      })), this.session.secret);
      return this.connection.publishEvent(event, encrypted, callWebhook);
    }
  }, {
    key: "handleIncomingEvent",
    value: function handleIncomingEvent(event) {
      var json;

      try {
        json = JSON.parse(aes256gcm.decrypt(event.data, this.session.secret));
      } catch (_a) {
        return;
      }

      var message = Web3ResponseMessage_1.isWeb3ResponseMessage(json) ? json : null;

      if (!message) {
        return;
      }

      this.handleWeb3ResponseMessage(message);
    }
  }, {
    key: "handleWeb3ResponseMessage",
    value: function handleWeb3ResponseMessage(message) {
      var _this4 = this;

      var response = message.response;

      if (Web3Response_1.isRequestEthereumAccountsResponse(response)) {
        Array.from(WalletLinkRelay.accountRequestCallbackIds.values()).forEach(function (id) {
          return _this4.invokeCallback(Object.assign(Object.assign({}, message), {
            id: id
          }));
        });
        WalletLinkRelay.accountRequestCallbackIds.clear();
        return;
      }

      this.invokeCallback(message);
    }
  }, {
    key: "invokeCallback",
    value: function invokeCallback(message) {
      var callback = WalletLinkRelay.callbacks.get(message.id);

      if (callback) {
        callback(message.response);
        WalletLinkRelay.callbacks.delete(message.id);
      }
    }
  }]);

  return WalletLinkRelay;
}();

WalletLinkRelay.callbacks = new Map();
WalletLinkRelay.accountRequestCallbackIds = new Set();

__decorate([bind_decorator_1.default], WalletLinkRelay.prototype, "resetAndReload", null);

__decorate([bind_decorator_1.default], WalletLinkRelay.prototype, "handleIncomingEvent", null);

exports.WalletLinkRelay = WalletLinkRelay;